<template>
  <!-- ===pdf -->
  <el-card class="pad" style="margin-top: 20px">
    <el-collapse v-model="activeName">
      <el-collapse-item title="处方单" name="1">
        <div class="pdf">
          <div class="pdf_card">
            <!-- 12-26新版本 -->
            <div class="pdf_title">
              <div class="titel_name">银川乐荐互联网医院处方单</div>
              <img
                :src="'data:image/jpg;base64,' + listData.hospitalSignature"
                alt
              />
            </div>
            <div class="pdf_type">普通处方</div>
            <div class="pdf_center">
              <div>处方编号：{{ listData.orderNo }}</div>
              <div class="user_listData">
                <span>姓名：{{ listData.orderTreatment.patientName }}</span>
                <span
                  >性别：{{
                    PATIENT_GENDER[listData.orderTreatment.patientGender]
                  }}</span
                >
                <span>年龄：{{ listData.orderTreatment.patientAge }}岁</span>
              </div>
              <div class="user_listData_date">
                <span>处方日期：{{ listData.startDate }}</span>
                <span>科室：{{ listData.departmentName }}</span>
                <span
                  >联系方式：{{ listData.orderTreatment.memberMobile }}</span
                >
              </div>
              <div>
                诊断：{{ listData.orderTreatmentCase.treatmentResName }}
              </div>
            </div>

            <div class="center_prescription">
              <div class="prescription_title">Rp：</div>
              <div
                class="prescription_list"
                v-for="(item, index) in listData.drugList"
                :key="index"
              >
                <span
                  >{{
                    listData.drugList.length == 1
                      ? "&nbsp;&nbsp;&nbsp;"
                      : index + 1 + "."
                  }}{{ item.drname }} &nbsp;&nbsp;({{ item.drmodel }})
                  &nbsp;&nbsp;x &nbsp;&nbsp; {{ item.drugNum
                  }}{{ drugNumSpcesObjAll[item.drugNumUnit] }}</span
                >
                <div>
                  用法：{{ item.dosage }}{{ item.dosageUnit }} &nbsp;&nbsp;{{
                    drugDirectionsObjAll[item.drugDirections]
                  }}
                  &nbsp;&nbsp;{{ item.frequencyUnit }}
                  <br />
                  备注：{{ item.remark }}
                </div>
              </div>
              <div class="prescription_list">
                <div>处方开写已结束 ！</div>
              </div>
            </div>
            <div class="pdf_footer">
              <div class="footer_flex">
                <div class="doctor">
                  开方医生：
                  <img
                    v-if="
                      listData.doctorSignature &&
                        listData.doctorSignatureStatus == '1'
                    "
                    :src="ImageUrl + listData.doctorSignature"
                    alt
                  />
                  <span v-else>未签字</span>
                </div>
              </div>
              <div class="footer_flex">
                <div class="doctor">
                  审核药师：
                  <img
                    v-if="
                      listData.pharmacistSignature &&
                        listData.pharmacistSignatureStatus == '1'
                    "
                    :src="ImageUrl + listData.pharmacistSignature"
                    alt
                  />
                  <span v-else>未签字</span>
                </div>
              </div>

              <div>
                <div class="doctor">合计金额：{{ listData.combined }}</div>
              </div>

              <div class="footer_flex footer_line">
                <div class="doctor">
                  {{ listData.prescriptionValidity || "" }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </el-card>
</template>

<script>
import { addDictMap } from "@/api";
import util from "@/utils";
import emptyData from "@/components/common/emptyData.vue";
import config from "@/config/config.js";
import { ORDER_TYPE, PATIENT_GENDER, ORDER_STATUS } from "@/utils/constants";

export default {
  name: "",
  components: { emptyData },
  ImageUrl: config.ImageUrl,
  props: {
    id: {
      required: false,
      type: [Number, String],
      default: "",
    },
    listData: {
      type: Object,
      default: {},
      createTime: "",
    },
  },
  data() {
    return {
      PATIENT_GENDER,
      // htmlTitle: "页面导出PDF文件名",
      ImageUrl: config.ImageUrl,
      activeName: "1",
      area: process.env.VUE_APP_AREA,
      copyrightFullName: process.env.VUE_APP_PR_TITLE,
      drugDirectionsObjAll: {},
      drugNumSpcesObjAll: {},
    };
  },
  created() {
    this.addDictMap();
  },
  methods: {
    async addDictMap() {
      const res = await addDictMap();
      if (res.code == 1) {
        const drugDirections = res.data.drugDirections || [];
        const drugNumSpce = res.data.drugNumSpce || [];
        const drugDirectionsObj = {};
        const drugNumSpcesObj = {};
        drugDirections.forEach((item) => {
          drugDirectionsObj[item.id] = item.name;
        });
        drugNumSpce.forEach((item) => {
          drugNumSpcesObj[item.id] = item.name;
        });
        this.drugDirectionsObjAll = drugDirectionsObj;
        this.drugNumSpcesObjAll = drugNumSpcesObj;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pdf {
  height: 100%;
  width: 60%;
  overflow-x: auto;
  overflow-y: auto;
  margin: 0 auto;
}

.pdf_type {
  //   position: absolute;
  width: 70px;
  float: right;
  margin-bottom: 50px;
  padding: 5px 5px;
  right: 5%;
  top: 60px;
  border: 1px solid #3b3b3b;
  color: #3b3b3b;
  font-size: 14px;
  text-align: center;
  font-weight: 600;
}

.pdf_card {
  padding: 0 15px;
}
.pdf::-webkit-scrollbar {
  width: 0;
}

.thumb {
  width: 100%;
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}
.pdf_text {
  text-align: center;
}
.pdf-box {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  max-width: 1024px;
  width: 100%;
  margin: 0 auto;
  overflow-x: hidden;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  font-size: 0.28rem;
}
span {
  width: 100%;
}

/* 12-26新版本 */
.pdf_title {
  position: relative;
  text-align: center;
  height: 100px;
  padding-top: 20px;
}
.pdf_title img {
  position: absolute;
  top: 23%;
  left: 50%;
  width: 90px;
  height: 90px;
  opacity: 0.6;
  transform: translateX(-50%);
}
.titel_name {
  /* height: 50px; */
  font-size: 20px;
  padding-top: 20px;
  font-weight: 700;
}
.report_number {
  font-size: 18px;
  font-weight: 600;
  color: #3b3b3b;
}
.pdf_center {
  font-size: 14px;
  /* color: #3b3b3b; */
  padding-bottom: 10px;
  border-bottom: 1px dashed #3b3b3b;
}

.pdf_center div {
  /* margin-top: 5px; */
}

.user_listData {
  display: flex;
}

.user_listData span {
  min-width: 33.3%;
}

.user_listData_date {
  display: flex;
}
.user_listData_date span {
  width: 66.6%;
}

.user_listData_date span:nth-child(2) {
  // width: 33.3%;
  position: relative;
}

.prescription_title {
  font-weight: 700;
  margin: 10px 0;
}
.center_prescription {
  min-height: 380px;
}
.prescription_list {
  font-size: 14px;
  margin-top: 5px;
}
.prescription_list div {
  padding-left: 10px;
  font-size: 14px;
}

.prescription_list:last-child {
  padding-bottom: 30px;
}
.pdf_footer {
  font-size: 14px;
  padding-bottom: 10px;
  padding-top: 5px;
  border-top: 1px dashed #3b3b3b;
}

.footer_flex {
  width: 100%;
  display: flex;
}
.footer_line {
  border-top: 1px dashed #3b3b3b;
  // margin-top: 15px;
}

.footer_flex .doctor {
  margin-top: 5px;
  width: 50%;
  position: relative;
}

.pdf_footer .doctor img {
  position: absolute;
  top: -5px;
  width: 55px;
  height: 40px;
}
</style>
